import getCountryName from '../utils/getCountryName';
import Cookies from 'js-cookie';
import {useUrl} from '@shopify/hydrogen';
import {useEffect} from 'react';
import {useGeoFenceCode} from './useGeoFenceCode';
import {
  COUNTRIES_MANAGED_BY_DISTRIBUTOR,
  COUNTRIES_WE_SHIP_TO,
} from '../constants';

export default function useGeo() {
  const {pathname} = useUrl();
  const setGeoFenceCode = useGeoFenceCode();
  const geoCookie =
    Cookies.get('geoClient') ||
    Cookies.get('geoServer') ||
    'xVercelIpCountry=nz;preferredCountry=nz';
  const {
    xVercelIpCountryCookie,
    preferredCountryCookie,
    acceptedWrongCountryCookie,
  } = extractCookie(geoCookie);

  const preferredCountryName = getCountryName(preferredCountryCookie) as string;
  const xVercelIpCountryName = getCountryName(xVercelIpCountryCookie) as string;

  // Current path
  const isSubpathRegex = /\/[a-z]{2}-[a-z]{2}\//;
  const subpath = pathname.split('/')[1].slice(0, 5);
  const isSubpath = isSubpathRegex.test(`/${subpath}/`);
  const currentCountryPath = isSubpath
    ? pathname.split('/')[1].slice(0, 2)
    : 'nz';
  const currentCountryPathName = getCountryName(currentCountryPath) as string;
  const onCorrectPath =
    currentCountryPath.toUpperCase() === xVercelIpCountryCookie &&
    (currentCountryPath.toUpperCase() === preferredCountryCookie ||
      preferredCountryCookie === 'XX');

  // Set shipping vars
  const isShippable = COUNTRIES_WE_SHIP_TO.includes(
    currentCountryPath.toUpperCase(),
  );
  const isManagedByDistributor = COUNTRIES_MANAGED_BY_DISTRIBUTOR.find(
    (c) => c.isoCode === currentCountryPath.toUpperCase(),
  );

  function setPreferredCountryCookie(
    isoCode: string,
    acceptedWrongCountry = false,
  ) {
    Cookies.set(
      'geoClient',
      `xVercelIpCountry=${xVercelIpCountryCookie};preferredCountry=${isoCode};acceptedWrongCountry=${acceptedWrongCountry}`,
    );
  }

  useEffect(() => {
    // console.log(`🔴 xVercelIpCountryCookie`, xVercelIpCountryCookie);
    // console.log(`🔴 preferredCountryCookie`, preferredCountryCookie);
    // console.log(`🔴 currentCountryPath`, currentCountryPath);
    // console.log(`🔴 acceptedWrongCountryCookie`, acceptedWrongCountryCookie);
    // console.log(`🔴 onCorrectPath`, onCorrectPath);
    // console.log(`🔴 isShippable`, isShippable);
    // console.log(`🔴 isManagedByDistributor`, isManagedByDistributor);

    setGeoFenceCode(currentCountryPath.toLocaleUpperCase());
  }, [currentCountryPath]);

  return {
    preferredCountryCookie,
    xVercelIpCountryCookie,
    acceptedWrongCountryCookie,
    preferredCountryName,
    xVercelIpCountryName,
    currentCountryPath,
    currentCountryPathName,
    onCorrectPath,
    isShippable,
    isManagedByDistributor,
    setPreferredCountryCookie,
  };
}

export function extractCookie(cookie: string) {
  const jar = cookie.split(';');
  return {
    xVercelIpCountryCookie: jar[0].split('=')[1],
    preferredCountryCookie: jar[1].split('=')[1],
    acceptedWrongCountryCookie: jar[2]?.split('=')[1] === 'true',
  };
}
